export default "__VITE_ASSET__3BGKJk0S__"